import { render, staticRenderFns } from "./BookingStatusBar.vue?vue&type=template&id=510c2716&scoped=true&"
import script from "./BookingStatusBar.vue?vue&type=script&lang=ts&"
export * from "./BookingStatusBar.vue?vue&type=script&lang=ts&"
import style0 from "./BookingStatusBar.vue?vue&type=style&index=0&id=510c2716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c2716",
  null
  
)

export default component.exports